//############## LANDING PAGE ACTIONS ##################
//FEATURED VEHICLES :
export const INIT_GET_FEATURED_VEHICLS = 'INIT_GET_FEATURED_VEHICLS';
export const GET_FEATURED_VEHICELS = 'GET_FEATURED_VEHICELS';
export const Fail_GET_FEATURED_VEHILELS = 'Fail_GET_FEATURED_VEHILELS';
//comming SOON:
export const COMMING_SOON = 'COMMING_SOON'; 
////FEATURED DEALERS :
export const INIT_GET_FEATURED_DEALERS = 'INIT_GET_FEATURED_DEALERS';
export const GET_FEATURED_DEALERS = 'GET_FEATURED_DEALERS';
export const Fail_GET_FEATURED_DEALERS = 'Fail_GET_FEATURED_DEALERS';

//############## SEARCH PAGE ACTIONS ##################


//###### VIEW STYLE
export const SEARCH_PAGE_VIEW_TYPE = 'SEARCH_PAGE_VIEW_TYPE';

// ############### VEHICLE TYPE

export const SEARCH_VEHICLE_TYPE = 'SEARCH_VEHICLE_TYPE';

//################# VEHICLE LIST :

export const INIT_GET_VEHICLE_ITEMS = 'INIT_GET_VEHICLE_ITEMS';
export const GET_VEHICLE_ITEMS = 'GET_VEHICLE_ITEMS';
export const SUCCESS_GET_VEHICLE_ITEMS = 'SUCCESS_GET_VEHICLE_ITEMS';
export const FAIL_GET_VEHICLE_ITEMS = 'FAIL_GET_VEHICLE_ITEMS';

//############## DETAIL PAGE ACTIONS ################## :
export const INIT_GET_DETAIL_ITEM = 'INIT_GET_DETAIL_ITEM';
export const GET_DETAIL_ITEM = 'GET_DETAIL_ITEM';
export const SUCCESS_GET_DETAIL_ITEM = 'SUCCESS_GET_DETAIL_ITEM';
export const FAIL_GET_DETAIL_ITEM = 'FAIL_GET_DETAIL_ITEM';
export const CHECK_ITEM_HAS_VIDEO = 'CHECK_ITEM_HAS_VIDEO';
export const CHECKING_HAS_VIDEO = 'CHECKING_HAS_VIDEO';
// add comment:
export const INIT_ADD_COMMENT = 'INIT_ADD_COMMENT';
export const POST_ADD_COMMENT = 'POST_ADD_COMMENT';
export const SUCCESS_ADD_COMMENT = 'SUCCESS_ADD_COMMENT';
export const FAIL_ADD_COMMENT = 'FAIL_ADD_COMMENT';

//############## AUTENTICATIONS ACTIONS ################## :
export const START_AUTHENTICATING = 'START_AUTHENTICATING'
export const INIT_AUTHENTICATING = 'INIT_AUTHENTICATING';
export const SUCCESS_AUTHENTICATING = 'SUCCESS_AUTHENTICATING';
export const CHANGED_USER_AUTHENTICATING = 'CHANGED_USER_AUTHENTICATING';
export const FAIL_AUTHENTICATING = 'FAIL_AUTHENTICATING';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const LOGOUT_AUTHENTICATION = 'LOGOUT_AUTHENTICATION';
export const SUCCESS_LOGOUT_AUTHENTICATION = 'SUCCESS_LOGOUT_AUTHENTICATION';
export const GOOGLE_AUTHENTICATION = 'GOOGLE_AUTHENTICATION';
// Current User Data  : 
export const GET_CURRENT_LOGED_USER_DATA = 'GET_CURRENT_LOGED_USER_DATA';
export const SUCCESS_GET_CURRENT_LOGED_USER_DATA = 'SUCCESS_GET_CURRENT_LOGED_USER_DATA';
export const FAIL_GET_CURRENT_LOGED_USER_DATA = 'FAIL_GET_CURRENT_LOGED_USER_DATA';

// ############### WISHLIST ACTIONS ####################### :
export const GET_WISHLIST = 'GET_WISHLIST';
export const INIT_GET_WISHLIST = 'INIT_GET_WISHLIST';
export const SUCCESS_GET_WISHLIST = 'SUCCESS_GET_WISHLIST';
export const FAIL_GET_WISHLIST = 'FAIL_GET_WISHLIST';
export const WISH_IDS_ARRAY = 'WISH_IDS_ARRAY';
//Adding new item to wihsList :
export const ADD_ITEM_TO_USER_WISHLIST = 'ADD_ITEM_TO_USER_WISHLIST';
export const INIT_ADD_ITEM_TO_USER_WISHLIST = 'INIT_ADD_ITEM_TO_USER_WISHLIST';
export const SUCCESS_ADD_ITEM_TO_USER_WISHLIST = 'SUCCESS_ADD_ITEM_TO_USER_WISHLIST';
export const FAIL_ADD_ITEM_TO_USER_WISHLIST = 'FAIL_ADD_ITEM_TO_USER_WISHLIST';
//Remove item from WihsList : 
export const REMOVE_ITEM_FROM_USER_WISHLIST = 'REMOVE_ITEM_FROM_USER_WISHLIST';
export const INIT_REMOVE_ITEM_FROM_USER_WISHLIST = 'INIT_REMOVE_ITEM_FROM_USER_WISHLIST';
export const SUCCESS_REMOVE_ITEM_FROM_USER_WISHLIST = 'SUCCESS_REMOVE_ITEM_FROM_USER_WISHLIST';
export const FAIL_REMOVE_ITEM_FROM_USER_WISHLIST = 'FAIL_REMOVE_ITEM_FROM_USER_WISHLIST';

// ############################# DEALER ACTIONS : :

export const GET_DEALER = 'GET_DEALER';
export const INIT_GET_DEALER = 'INIT_GET_DEALER';
export const SUCCESS_GET_DEALER = 'SUCCESS_GET_DEALER';
export const FAIL_GET_DEALER = 'FAIL_GET_DEALER';
// GET Dealer POSTS : 
export const GET_DEALER_POSTS = 'GET_DEALER_POSTS';
export const INIT_GET_DEALER_POSTS = 'INIT_GET_DEALER_POSTS';
export const SUCCESS_GET_DEALER_POSTS = 'SUCCESS_GET_DEALER_POSTS';
export const FAIL_GET_DEALER_POSTS = 'FAIL_GET_DEALER_POSTS';

// #############################################Get USER PROFILE : 
export const GET_USER_PROFILE = 'GET_USER_PROFILE';
export const INIT_GET_USER_PROFILE = 'INIT_GET_USER_PROFILE';
export const SUCCESS_GET_USER_PROFILE = 'SUCCESS_GET_USER_PROFILE';
export const FAIL_GET_USER_PROFILE = 'FAIL_GET_USER_PROFILE';

// ########################################## EDITE USER PROFILE :

export const Edit_USER_PROFILE = 'Edit_USER_PROFILE';
export const INIT_Edit_USER_PROFILE = 'INIT_Edit_USER_PROFILE';
export const SUCCESS_Edit_USER_PROFILE = 'SUCCESS_Edit_USER_PROFILE';
export const FAIL_Edit_USER_PROFILE = 'FAIL_Edit_USER_PROFILE';

// ################################### Messages :

export const Get_Messages = 'Get_Messages';
export const INIT_Get_Messages = 'INIT_Get_Messages';
export const SUCCESS_Get_Messages = 'SUCCESS_Get_Messages';
export const FAIL_Get_Messages = 'FAIL_Get_Messages';

// ################################## Chat :

export const GET_CHAT = 'GET_CHAT';
export const INIT_GET_CHAT = 'INIT_GET_CHAT';
export const SUCCESS_GET_CHAT = 'SUCCESS_GET_CHAT';
export const FAIL_GET_CHAT = 'FAIL_GET_CHAT';
//clean Chat:
export const CLEAN_CHAT = 'CLEAN_CHAT';
// get all Users :
export const GET_ALL_USERS = 'GET_ALL_USERS';
export const INIT_ALL_USERS = 'INIT_ALL_USERS';
export const SUCCESS_ALL_USERS = 'SUCCESS_ALL_USERS';
export const FAIL_ALL_USERS = 'FAIL_ALL_USERS';
// Create message (send message):
export const CREATE_MESSAGE = 'CREATE_MESSAGE';
export const INIT_CREATE_MESSAGE = 'INIT_CREATE_MESSAGE';
export const SUCCESS_CREATE_MESSAGE = 'SUCCESS_CREATE_MESSAGE';
export const FAIL_CREATE_MESSAGE = 'FAIL_CREATE_MESSAGE';
// Set as read :
export const SET_AS_READ = 'SET_AS_READ';

// #################################### CONTACT NOW :

export const TOGGEL_CONTACT_NOW = 'TOGGEL_CONTACT_NOW'; 
// Create new Chat:
export const CREATE_NEW_CHAT = 'CREATE_NEW_CHAT'; 